import styled from 'styled-components';

const ContactFormStepStyle = styled.ul`
	&.pageCountWrap {
		--size: 32px;

		.pageCount {
			width: var(--size);
			height: calc(var(--size) + 3px);
			position: relative;
			margin: var(--sp1x);

			span {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate3d(-50%, -50%, 0);
			}

			svg {
				stroke: var(--color2);
				stroke-width: 2;
				fill: none;
			}

			&.active {
				cursor: pointer;
			}
		}

		&.deactivate {
			pointer-events: none;
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			.pageCount {
				margin: var(--sp1x) var(--sp2x);
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
			display: flex;
			justify-content: center;
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			--size: 56px;
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
			.pageCount {
				margin: var(--sp4x) auto;
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
			--size: 48px;
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
			--size: 54px;
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
			--size: 61px;
		}
	}
`;

export default ContactFormStepStyle;
